<template>
  <v-container fluid>
    <v-row>
      <v-col class="pb-0">
        <v-tabs v-model="tabs" fixed-tabs centered>
          <v-tab>요약정보</v-tab>
          <v-tab>상세정보</v-tab>
          <v-tab>고장정보</v-tab>
        </v-tabs>
      </v-col>
      <v-col cols="2" class="pb-0">
        <v-select
          outlined
          solo
          dense
          hide-details
          @change="changeSubComp"
          class="d-inline-flex"
          :items="comboList"
          v-model="select"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-tabs-items
          v-model="tabs"
        >
          <v-tab-item>
            <v-container class="pa-0" fluid>
              <v-row>
                <v-col>
                  <p class="pt-3">배터리 요약정보</p>
                  <v-simple-table
                    fixed-header
                  >
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-center" colspan="2">SOC</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_SOC}}
                          <span class="tr-caption-style">%</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" colspan="2">SOH</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_SOH}}
                          <span class="tr-caption-style">%</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" colspan="2">전압</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_V}}
                          <span class="tr-caption-style">V</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" colspan="2">전류</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_I}}
                          <span class="tr-caption-style">A</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" rowspan="2">모듈온도</th>
                        <th class="text-center">최고</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_HiModTemp}}
                          <span class="tr-caption-style">℃</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">최저</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_LoModTemp}}
                          <span class="tr-caption-style">℃</span>
                        </td>
                      </tr>
                      </thead>
                    </template>
                  </v-simple-table>
                </v-col>
                <v-col>
                  <v-row>
                    <v-col>
                      <p>배터리 현재 상태</p>
                      <v-simple-table
                      >
                        <template v-slot:default>
                          <thead>
                          <tr>
                            <th class="text-center">충전전력</th>
                            <th class="text-center">운전전력
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td class="tr-value-style text-center">
                              {{BSC.BSC_ReqPower}}
                              <span class="tr-caption-style">kW</span>
                            </td>
                            <td class="tr-value-style text-center">
                              {{BSC.BSC_STATUS_NAME}}
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-0">
                      <p>배터리룸 상태</p>
                      <v-simple-table
                      >
                        <template v-slot:default>
                          <thead>
                          <tr>
                            <th class="text-center">구분</th>
                            <th class="text-center">배터리룸 #1</th>
                            <th class="text-center">배터리룸 #2</th>
                            <th class="text-center">배터리룸 #3</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td class="text-center">온도</td>
                            <td class="tr-value-style text-center">
                              {{CTH01.CTH_Con1_Temp}}
                              <span class="tr-caption-style" v-if="CTH01.CTH_Con1_Temp">℃</span>
                              <span class="tr-caption-style" v-else>-</span>
                            </td>
                            <td class="tr-value-style text-center">
                              {{CTH02.CTH_Con1_Temp}}
                              <span class="tr-caption-style" v-if="CTH02.CTH_Con1_Temp">℃</span>
                              <span class="tr-caption-style" v-else>-</span>
                            </td>
                            <td class="tr-value-style text-center">
                              {{CTH03.CTH_Con1_Temp}}
                              <span class="tr-caption-style" v-if="CTH03.CTH_Con1_Temp">℃</span>
                              <span class="tr-caption-style" v-else>-</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-center">습도</td>
                            <td class="tr-value-style text-center">
                              {{CTH01.CTH_Con1_Humid}}
                              <span class="tr-caption-style" v-if="CTH01.CTH_Con1_Humid">℃</span>
                              <span class="tr-caption-style" v-else>-</span>
                            </td>
                            <td class="tr-value-style text-center">
                              {{CTH02.CTH_Con1_Humid}}
                              <span class="tr-caption-style" v-if="CTH02.CTH_Con1_Humid">℃</span>
                              <span class="tr-caption-style" v-else>-</span>
                            </td>
                            <td class="tr-value-style text-center">
                              {{CTH03.CTH_Con1_Humid}}
                              <span class="tr-caption-style" v-if="CTH03.CTH_Con1_Humid">℃</span>
                              <span class="tr-caption-style" v-else>-</span>
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p>에어컨 상태</p>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-center">구분</th>
                        <th class="text-center">에어컨 #1</th>
                        <th class="text-center">에어컨 #2</th>
                        <th class="text-center">에어컨 #3</th>
                        <th class="text-center">에어컨 #4</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="text-center">현재온도</td>
                        <td class="tr-value-style text-center">
                          {{HVAC01.HVAC_CurrentRoomTemperature}}
                          <span class="tr-caption-style" v-if="HVAC01.HVAC_CurrentRoomTemperature">℃</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                        <td class="tr-value-style text-center">
                          {{HVAC02.HVAC_CurrentRoomTemperature}}
                          <span class="tr-caption-style" v-if="HVAC02.HVAC_CurrentRoomTemperature">℃</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                        <td class="tr-value-style text-center">
                          {{HVAC03.HVAC_CurrentRoomTemperature}}
                          <span class="tr-caption-style" v-if="HVAC03.HVAC_CurrentRoomTemperature">℃</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                        <td class="tr-value-style text-center">
                          {{HVAC04.HVAC_CurrentRoomTemperature}}
                          <span class="tr-caption-style" v-if="HVAC04.HVAC_CurrentRoomTemperature">℃</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center">설정온도</td>
                        <td class="tr-value-style text-center">
                          {{HVAC01.HVAC_SetTemperature}}
                          <span class="tr-caption-style" v-if="HVAC01.HVAC_SetTemperature">℃</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                        <td class="tr-value-style text-center">
                          {{HVAC02.HVAC_SetTemperature}}
                          <span class="tr-caption-style" v-if="HVAC02.HVAC_SetTemperature">℃</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                        <td class="tr-value-style text-center">
                          {{HVAC03.HVAC_SetTemperature}}
                          <span class="tr-caption-style" v-if="HVAC03.HVAC_SetTemperature">℃</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                        <td class="tr-value-style text-center">
                          {{HVAC04.HVAC_SetTemperature}}
                          <span class="tr-caption-style" v-if="HVAC04.HVAC_SetTemperature">℃</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center">운전상태</td>
                        <td class="text-center">
                          <span v-if="HVAC01.HVAC_RunningStatus">{{HVAC01.HVAC_Status_Name}}</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                        <td class="text-center">
                          <span v-if="HVAC02.HVAC_RunningStatus">{{HVAC02.HVAC_Status_Name}}</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                        <td class="text-center">
                          <span v-if="HVAC03.HVAC_RunningStatus">{{HVAC03.HVAC_Status_Name}}</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                        <td class="text-center">
                          <span v-if="HVAC04.HVAC_RunningStatus">{{HVAC04.HVAC_Status_Name}}</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center">운전모드</td>
                        <td class="text-center">
                          <span v-if="HVAC01.HVAC_Mode">{{HVAC01.HVAC_Mode_Name}}</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                        <td class="text-center">
                          <span v-if="HVAC02.HVAC_Mode">{{HVAC02.HVAC_Mode_Name}}</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                        <td class="text-center">
                          <span v-if="HVAC03.HVAC_Mode">{{HVAC03.HVAC_Mode_Name}}</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                        <td class="text-center">
                          <span v-if="HVAC04.HVAC_Mode">{{HVAC04.HVAC_Mode_Name}}</span>
                          <span class="tr-caption-style" v-else>-</span>
                        </td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container class="pa-0" fluid>
              <v-row>
                <v-col>
                  <p>배터리 상세정보</p>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-center">온라인 상태</th>
                        <th class="text-center">경고 상태</th>
                        <th class="text-center">고장 상태</th>
                        <th class="text-center">충/방전 상태</th>
                        <th class="text-center">SOC 알림 상태</th>
                        <th class="text-center">Contactor control</th>
                        <th class="text-center">Rack balancing</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="text-center">
                          <span class="big_txt">{{BSC.BSC_OnlineRack}}</span>
                        </td>
                        <td class="text-center">
                          <span class="big_txt">{{BSC.BSC_WarnRack}}</span>
                        </td>
                        <td class="text-center">
                          <span class="big_txt">{{BSC.BSC_FaultRack}}</span>
                        </td>
                        <td class="text-center">
                          <span class="tr-value-style">{{BSC.BSC_STATUS}}</span>
                        </td>
                        <td class="text-center">
                        </td>
                        <td class="text-center">
                          <span class="big_txt">{{BSC.BSC_ContactAck}}</span>
                        </td>
                        <td class="text-center">
                          <span class="big_txt">{{BSC.BSC_BalRack}}</span>
                        </td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-simple-table
                    fixed-header
                  >
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th class="text-center" colspan="2">SOC</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_SOC}}
                          <span class="tr-caption-style">%</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" colspan="2">SOH</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_SOH}}
                          <span class="tr-caption-style">%</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" rowspan="2">DC 입력</th>
                        <th class="text-center">전압</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_V}}
                          <span class="tr-caption-style">V</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">전류</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_I}}
                          <span class="tr-caption-style">A</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" rowspan="2">충전제한</th>
                        <th class="text-center">전압</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_CharCurLimit}}
                          <span class="tr-caption-style">A</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">전류</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_CharPowerLimit}}
                          <span class="tr-caption-style">kW</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" rowspan="2">방전제한</th>
                        <th class="text-center">전압</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_DisCurLimit}}
                          <span class="tr-caption-style">A</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">전류</th>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_DisPowerLimit}}
                          <span class="tr-caption-style">kW</span>
                        </td>
                      </tr>
                      </thead>
                    </template>
                  </v-simple-table>
                </v-col>
                <v-col>
                  <v-simple-table
                    fixed-header
                  >
                    <template v-slot:default>
                      <thead class="ess">
                      <tr>
                        <th class="text-center" rowspan="4">셀전압</th>
                        <th class="text-center" rowspan="2">최고</th>
                        <td class="text-center">전압</td>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_HiCelVolt}}
                          <span class="tr-caption-style">V</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center">위치</td>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_HiCelLoc}}
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" rowspan="2">최저</th>
                        <td class="text-center">전압</td>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_LoCelVolt}}
                          <span class="tr-caption-style">kW</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center">위치</td>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_LoCelLoc}}
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" rowspan="4">모듈온도</th>
                        <th class="text-center" rowspan="2">최고</th>
                        <td class="text-center">온도</td>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_HiModTemp}}
                          <span class="tr-caption-style">℃</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center">위치</td>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_HiTempLoc}}
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" rowspan="2">최저</th>
                        <td class="text-center">온도</td>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_LoModTemp}}
                          <span class="tr-caption-style">℃</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center">위치</td>
                        <td class="tr-value-style text-center">
                          {{BSC.BSC_LoTempLoc}}
                        </td>
                      </tr>
                      </thead>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container class="pa-0" fluid>
              <v-data-iterator
                :items="breakInfo"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >
                <template v-slot:header>
                  <p>배터리 고장정보</p>
                  <p class="text-body-2">
                    고장정보 체크 시점일
                    <span class="pl-6 txt-blue">2019.05.20 13:41</span>
                  </p>
                </template>
                <template v-slot:default="props">
                  <v-row>
                    <v-col
                      v-for="item in props.items"
                      :key="item.name"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="2"
                    >
                      <v-card
                        width="350"
                        min-width="310"
                        style="background-color: inherit !important;"
                        class="elevation-0">
                        <v-card-title
                          class="text-subtitle-2">
                          <div
                            class="rounded-circle d-inline-block mr-10"
                            style="width: 25px; height: 25px; background: #d42a46"
                            v-if="item.condition"
                          ></div>
                          <div
                            class="rounded-circle d-inline-block mr-10"
                            style="width: 25px; height: 25px; background: #bdbdbd"
                            v-else
                          ></div>
                          {{item.title}}
                        </v-card-title>
                        <v-divider></v-divider>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'WorkBattrey',
  props: {
    site_id: { type: String, default: '' },
    essData: { type: [Object, Object], default: undefined }
  },
  data() {
    return {
      tabs: 0,
      select: '',
      itemsPerPage: 100,
      tabList: [
        { label: '요약정보', name: 'summary', isOn: true },
        { label: '상세정보', name: 'detail', isOn: false },
        { label: '고장정보', name: 'break', isOn: false }
      ],
      item: [],
      BSC: {
        BSC_WarnCode: 0,
        BSC_SOC: 0,
        BSC_SOH: 0,
        BSC_V: 0,
        BSC_I: 0,
        BSC_HiModTemp: 0,
        BSC_LoModTemp: 0,
        BSC_OnlineRack: 0,
        BSC_WarnRack: 0,
        BSC_FaultRack: 0,
        BSC_STATUS: 0,
        BSC_ContactAck: 0,
        BSC_BalRack: 0,
        BSC_CharCurLimit: 0,
        BSC_CharPowerLimit: 0,
        BSC_DisCurLimit: 0,
        BSC_DisPowerLimit: 0,
        BSC_HiCelVolt: 0,
        BSC_HiCelLoc: 0,
        BSC_LoCelVolt: 0,
        BSC_LoCelLoc: 0,
        BSC_FaultCode: 0
      },
      HVAC: [],
      HVAC01: {},
      HVAC02: {},
      HVAC03: {},
      HVAC04: {},
      CTH: [],
      CTH01: {
        CTH_Con1_Temp: 0,
        CTH_Con1_Humid: 0
      },
      CTH02: {},
      CTH03: {},
      essResult: [
        {
          codeId: 'ess 배터리 1'
        }
      ]
    }
  },
  watch: {
    essData() {
      this.initData()
    },
    comboList() {
      this.select = this.comboList[0].value
    }
  },
  mounted() {
    this.initData()
  },
  computed: {
    comboList() {
      let list = []
      for (let item of this.essResult) {
        if (item.photo === 'BSC') {
          list.push({
            text: item.description,
            value: item.codeid
          })
        }
      }
      this.select = list[0]
      return list
    },

    breakInfo() {
      return [
        {
          title: '충전 과전류 경고',
          condition: this.BSC.BSC_WarnCode === '1.0'
        },
        {
          title: '충전 전력 제한 초과 경고',
          condition: this.BSC.BSC_WarnCode === '4.0'
        },
        {
          title: '다른 고장에 의한 렉 경고',
          condition: this.BSC.BSC_WarnCode === '16.0'
        },
        {
          title: '충전 과전류 고장',
          condition: this.BSC.BSC_FaultCode === '64.0'
        },
        {
          title: '충전 전력 제한 초과 고장',
          condition: this.BSC.BSC_FaultCode === '256.0'
        },
        {
          title: '오프라인 렉 개수 초과 고장',
          condition: this.BSC.BSC_FaultCode === '1024.0'
        },
        {
          title: '전체 렉 고장',
          condition: this.BSC.BSC_FaultCode === '4096.0'
        },
        {
          title: '방전 과전류 경고',
          condition: this.BSC.BSC_WarnCode === '2.0'
        },
        {
          title: '방전 전력 제한 초과 경고',
          condition: this.BSC.BSC_WarnCode === '8.0'
        },
        {
          title: '전체 렉 경고',
          condition: this.BSC.BSC_WarnCode === '32.0'
        },
        {
          title: '방전 과전류 고장',
          condition: this.BSC.BSC_FaultCode === '128.0'
        },
        {
          title: '방전 전력 제한 초과 고장',
          condition: this.BSC.BSC_FaultCode === '512.0'
        },
        {
          title: '초기화 고장',
          condition: this.BSC.BSC_FaultCode === '2048.0'
        }
      ]
    }
  },
  methods: {
    initData() {
      if (this.essData.result !== 'noData') {
        this.item = this.essData
        this.essResult = this.item.essResult

        if (this.item.essData.filter(d => d.HVAC).length !== 0) {
          this.HVAC = this.item.essData.filter(d => d.HVAC)

          for (let index = 0; index < this.HVAC.length; index++) {
            if (index === 0) {
              this.HVAC01 = this.HVAC.filter(
                d => d.subcomp === 'HVAC01'
              )[0].HVAC
            } else if (index === 1) {
              this.HVAC02 = this.HVAC.filter(
                d => d.subcomp === 'HVAC02'
              )[0].HVAC
            } else if (index === 2) {
              this.HVAC03 = this.HVAC.filter(
                d => d.subcomp === 'HVAC03'
              )[0].HVAC
            } else if (index === 3) {
              this.HVAC04 = this.HVAC.filter(
                d => d.subcomp === 'HVAC04'
              )[0].HVAC
            }
          }
        }
        if (this.item.essData.filter(d => d.BSC).length !== 0) {
          this.BSC = this.item.essData.filter(d => d.BSC)[0].BSC
        }

        if (this.item.essData.filter(d => d.CTH).length !== 0) {
          this.CTH = this.item.essData.filter(d => d.CTH)

          for (let index = 0; index < this.CTH.length; index++) {
            if (index === 0) {
              this.CTH01 = this.CTH.filter(d => d.subcomp === 'CTH01')[0].CTH
            } else if (index === 1) {
              this.CTH02 = this.CTH.filter(d => d.subcomp === 'CTH02')[0].CTH
            } else if (index === 2) {
              this.CTH03 = this.CTH.filter(d => d.subcomp === 'CTH03')[0].CTH
            }
          }
        }
      }
    },
    changeSubComp(e) {
      let codeID = e.target.value
      this.BSC = this.item.essData
        .filter(d => d.BSC)
        .filter(d => d.BSC.BSC_CODEID === codeID)[0].BSC
    },
    changeTab(key) {
      $("span[name='sub_tab_battery']").removeClass('on')
      $('#tab_battery_' + key).addClass('on')

      $("div[name='battery_tab']").removeClass('on')
      $('#battery_' + key).addClass('on')
    }
  }
}
</script>

<style lang="less" scoped>
.txt-blue {
  color: var(--v-txtblue-base) ;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  /*background-color: var(--v-hth-base);*/
  background-color: var(--v-hth-base);
  border: thin solid var(--v-hthline-base);
  color: var(--v-hthtext-base);
  font-size: 14px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  /*background-color: var(--v-hth-base);*/
  border: thin solid var(--v-hthline-base);
  font-size: 14px;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > td {
  /*background-color: var(--v-hth-base);*/
  border: thin solid var(--v-hthline-base);
  font-size: 14px;
}
</style>
